import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule } from '@spartacus/core';
import { MyaccountYourCredentialsComponent } from './myaccount-your-credentials.component';

@NgModule({
  declarations: [MyaccountYourCredentialsComponent],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MyAccountAccountInfoYourCredentialsFlexComponent: {
          component: MyaccountYourCredentialsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
})
export class MyaccountYourCredentialsModule {}
